/**
 * MIC-2 — pure helpers for search filter + progress sort.
 * Spec §2: uncounted float to top; counted sink to bottom.
 * Search matches material name / SKU (code), case-insensitive.
 */

export type InventoryCountLineSearchable = {
  id: string;
  material_name?: string;
  material_code?: string;
  counted_qty: number | null;
};

export function filterInventoryCountLinesBySearch<T extends InventoryCountLineSearchable>(
  lines: readonly T[],
  query: string
): T[] {
  const q = query.trim().toLowerCase();
  if (!q) return [...lines];
  return lines.filter((l) => {
    const name = (l.material_name ?? "").toLowerCase();
    const code = (l.material_code ?? "").toLowerCase();
    return name.includes(q) || code.includes(q);
  });
}

/** Uncounted first, then counted; stable by original order within each group. */
export function sortInventoryCountLinesByProgress<T extends InventoryCountLineSearchable>(
  lines: readonly T[]
): T[] {
  const uncounted: T[] = [];
  const counted: T[] = [];
  for (const line of lines) {
    if (line.counted_qty == null) uncounted.push(line);
    else counted.push(line);
  }
  return [...uncounted, ...counted];
}

export function prepareInventoryCountLinesForDisplay<T extends InventoryCountLineSearchable>(
  lines: readonly T[],
  query: string
): T[] {
  return sortInventoryCountLinesByProgress(filterInventoryCountLinesBySearch(lines, query));
}
